import React from 'react';

// Utils
import { getUniqueKey } from 'utils/string';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  name?: string;
  value?: string;
  selected?: boolean;
  label?: React.ReactNode;
}

const Radio: React.FC<Props> = ({ name, value, label, ...rest }) => {
  const radioId = getUniqueKey();

  return (
    <div className="radio-btn">
      <input type="radio" className="radio-input" id={radioId.toString()} name={name} value={value} {...rest} />
      <label className="radio-label" htmlFor={radioId.toString()}>
        <div className="radio-label__bulb"></div>
        <div className="radio-label__content">{label || value}</div>
      </label>
    </div>
  );
};

export default Radio;
